import Vue from 'vue'
import Vuex from 'vuex'
import session from './modules/session'
import staging from './modules/staging'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    session,
    staging,
  }
})
